import PinList from "@/components/PinList";
import styles from "./index.module.less";
import { useRecommendPins } from "./useRecommendPins";

export default function RecommendPins({
  boardId,
  pins,
}: {
  boardId: number;
  pins: { file_id: number }[];
}) {
  const { pins: list, hasMore, onLoadMore } = useRecommendPins(boardId, pins);

  if (!list?.length) {
    return null;
  }

  return (
    <div>
      <div className={styles.title}>更多采集推荐</div>
      <div className={styles.pins} data-content-source="更多采集推荐">
        <PinList
          dataSource={list}
          hasMore={hasMore}
          showBoardLink={false}
          onLoadMore={onLoadMore}
          masonryKey="BoardRecommendPins"
        ></PinList>
      </div>
    </div>
  );
}
